import ContentCardDisplay from './ContentCardDisplay';

export default ContentCardDisplay;
